import React from "react";
import EurocrossLogo from "../assets/eurocross_logo.svg";
const Footer = () => {
  return (
    <div className="footer">
      <div>
        <div className="footerSection1">
          <img src={EurocrossLogo} alt="Eurocross" />
          <div>Premium EU-GMP certified medications with cutting-edge digital trust features.</div>
        </div>
        <div className="footerSection2">
          <div className="footer_headers">Contact Us</div>
          {/* <div>Saveo Healthtech Private Limited</div> */}
          <div>Building No.: New 79/2</div>
          <div>Road : New Timber Yard Layout</div>
          <div>City : Bangalore, Bengaluru Urban</div>
          <div>State: Karnataka, PIN Code: 560026</div>
        </div>
        <div className="footerSection3">
          <div className="footer_headers">Get In Touch</div>
          <div>
            <div className="color_grey">Phone:</div>
            <div>+91-8762068888</div>
          </div>
          <div>
            <div className="color_grey">Email:</div>
            <div>support@eurocross.in</div>
          </div>
        </div>
      </div>
      <br />
      <hr className="border_grey" />
      <div className="footer_copy_rights">
        <div>© 2025 Eurocross by Saveo Healthtech Private Limited. All rights reserved.</div>
        <div>
          <span>Privacy Policy</span>
          &nbsp;&nbsp;&nbsp;
          <span>Terms of Use</span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
